import { FormDataControl, FormDataCheckbox, FormDataFile } from '../components/FormFields'

export function hideDialog(setDialogProps: any) {
  setDialogProps((dialogType: any) => {
    return {
      ...dialogType,
      show: false,
    }
  })
}

export function getDataField(attribute: any, customField?: string, index?: number) {
  switch (attribute.type.toUpperCase()) {
    case 'LIST':
    case 'STRING':
    case 'TEXT':
    case 'PASSWORD':
    case 'INTEGER':
    case 'LONG':
      return {
        id: attribute.name,
        type: getDataType(attribute.type),
        label: attribute.label,
        placeholder: attribute.example ? attribute.example : attribute.label,
        required: attribute.required,
        value: attribute.value ? attribute.value : attribute.default,
        plaintext: attribute.plaintext,
        readOnly: attribute.readOnly,
        onChange: attribute.onChange,
        disabled: attribute.disabled,
        autoComplete: getAutoComplete(attribute.type),
        render: customField ? (custom: string[]) => customField === custom[index ? index : 0] : true,
        ...addConstraints(attribute),
      }
    case 'BOOLEAN':
      return {
        groupLabel: attribute.label,
        groupName: attribute.label,
        type: 'switch',
        render: customField ? (custom: string[]) => customField === custom[index ? index : 0] : true,
        checkboxes: [
          {
            id: attribute.name,
            value:
              attribute.value !== undefined
                ? JSON.parse(attribute.value.toString().toLowerCase())
                : attribute.default !== undefined && JSON.parse(attribute.default.toString().toLowerCase()),
            disabled: attribute.disabled,
            onChange: attribute.onChange,
          },
        ],
      }
    case 'ENUM':
      return {
        id: attribute.name,
        type: 'select',
        options: attribute.options.map((option: any) => ({ label: option.key, value: option.value })),
        value: attribute.value ? attribute.value : attribute.options[0].value,
        label: attribute.label,
        onChange: attribute.onChange,
        required: attribute.required,
      }
    default:
      return {}
  }
}

function getDataType(type: string) {
  switch (type.toUpperCase()) {
    case 'INTEGER':
    case 'LONG':
      return 'number'
    case 'TEXT':
      return 'textarea'
    case 'PASSWORD':
      return 'password'
    default:
      return 'text'
  }
}

function getAutoComplete(type: string) {
  if (type.toUpperCase() === 'PASSWORD') {
    return 'new-password'
  }
  return undefined
}

function addConstraints(attribute: any) {
  return attribute.constraints?.reduce((obj: any, constraint: any) => {
    switch (constraint.name.toUpperCase()) {
      case 'RANGE':
        const range = constraint.value.split('-')
        obj.min = range[0]
        obj.minInvalidMessage = constraint.message
        obj.max = range[1]
        obj.maxInvalidMessage = constraint.message
        break
      case 'SIZE':
        const size = constraint.value.split('-')
        obj.minLength = size[0]
        obj.minLengthInvalidMessage = constraint.message
        obj.maxLength = size[1]
        obj.maxLengthInvalidMessage = constraint.message
        break
      case 'NOTEMPTY':
      case 'NOTBLANK':
      case 'NOTNULL':
        obj.requiredMessage = constraint.message
        break
    }
    return obj
  }, {})
}

export function getCustomErrorClass(validity: any) {
  if (validity.valid) {
    return 'valid'
  }
  if (validity.valueMissing === true) {
    return 'required'
  }
  if (validity.rangeUnderflow === true) {
    return 'min'
  }
  if (validity.rangeOverflow === true) {
    return 'max'
  }
  if (validity.tooShort === true) {
    return 'minLength'
  }
  if (validity.tooLong === true) {
    return 'maxLength'
  }
  if (validity.patternMismatch === true) {
    return 'pattern'
  }
  if (validity.stepMismatch === true) {
    return 'step'
  }
  return 'invalid'
}

export function getFormValidation(formData: any): any {
  return Object.keys(formData).reduce((obj: any, element: any) => {
    obj[element] = ''
    return obj
  }, {})
}

export function checkFormIntegrity(formData: any, form: any, setFormValues: React.Dispatch<any>, setFormValidation: React.Dispatch<any>) {
  if (
    !(
      Object.keys(formData).every((element) => Object.keys(form).includes(element)) &&
      Object.keys(form).every((element) => Object.keys(formData).includes(element))
    )
  ) {
    setFormValues(formData)
    setFormValidation(getFormValidation(formData))
  }
}

function isEditDataInput(obj: FormDataControl | FormDataCheckbox | FormDataFile): obj is FormDataControl {
  return ['number', 'text', 'textarea', 'password', 'email', 'hidden', 'select', 'typeAhead', 'multiSelect'].includes(obj.type)
}

function isEditDataCheckbox(obj: FormDataControl | FormDataCheckbox | FormDataFile): obj is FormDataCheckbox {
  return ['checkbox', 'radio', 'switch'].includes(obj.type)
}
function isEditDataFile(obj: FormDataControl | FormDataCheckbox | FormDataFile): obj is FormDataFile {
  return obj.type === 'file'
}

export const getDataArray = (
  custom: string[],
  data: (FormDataControl | FormDataCheckbox | FormDataFile)[] | ((custom: string[]) => (FormDataControl | FormDataCheckbox | FormDataFile)[])
) => {
  const returnData = Array.isArray(data) ? data : data(custom)
  return returnData
}

export function getFormData(
  custom: string[],
  data: (FormDataControl | FormDataCheckbox | FormDataFile)[] | ((custom: string[]) => (FormDataControl | FormDataCheckbox | FormDataFile)[])
) {
  return getDataArray(custom, data).reduce((obj: any, item: FormDataControl | FormDataCheckbox | FormDataFile) => {
    if (isEditDataInput(item) || isEditDataFile(item)) {
      const { id, value = '' } = item
      obj[id] = value
    } else if (isEditDataCheckbox(item)) {
      item.checkboxes.reduce((obj: any, checkbox: any) => {
        const { id, value = false } = checkbox
        obj[id] = value
        return obj
      }, obj)
    }
    return obj
  }, {})
}
